module.exports = __webpack_public_path__ + "./fonts/Muli-BlackItalic.ttf";